export class RsyncFindConditionViewModel {
    targetOperation = null;
    syncId = null;
    failureDateFrom = null;
    failureDateTo = null;
    userCd = null;
    userName = "";
    buknCd = null;
    buknName = "";
    nyukyokeiyakuNo = null;
    nyukyoshaName = "";
    clear() {
        this.targetOperation = null;
        this.syncId = null;
        this.failureDateFrom = null;
        this.failureDateTo = null;
        this.userCd = null;
        this.userName = "";
        this.buknCd = null;
        this.buknName = "";
        this.nyukyokeiyakuNo = null;
        this.nyukyoshaName = "";
    }
    copyFrom(condition) {
        this.targetOperation = condition.targetOperation;
        this.syncId = condition.syncId;
        this.failureDateFrom = condition.failureDateFrom;
        this.failureDateTo = condition.failureDateTo;
        this.userCd = condition.userCd;
        this.userName = condition.userName;
        this.buknCd = condition.buknCd;
        this.buknName = condition.buknName;
        this.nyukyokeiyakuNo = condition.nyukyokeiyakuNo;
        this.nyukyoshaName = condition.nyukyoshaName;
    }
    get summary() {
        let txt = "";
        const getDelimiter = function (text) {
            return text.length === 0 ? "" : "、 ";
        };
        if (this.targetOperation) {
            txt += getDelimiter(txt);
            txt += `対象操作:${this.targetOperation.label}`;
        }
        if (this.syncId) {
            txt += getDelimiter(txt);
            txt += `同期ID:${this.syncId}`;
        }
        if (this.failureDateFrom) {
            txt += getDelimiter(txt);
            txt += `連携失敗日(From):${this.failureDateFrom}`;
        }
        if (this.failureDateTo) {
            txt += getDelimiter(txt);
            txt += `連携失敗日(To):${this.failureDateTo}`;
        }
        if (this.userCd) {
            txt += getDelimiter(txt);
            txt += `契約者コード:${this.userCd}`;
        }
        if (this.userName) {
            txt += getDelimiter(txt);
            txt += `契約者名:${this.userName}`;
        }
        if (this.buknCd) {
            txt += getDelimiter(txt);
            txt += `物件コード:${this.buknCd}`;
        }
        if (this.buknName) {
            txt += getDelimiter(txt);
            txt += `物件名:${this.buknName}`;
        }
        if (this.nyukyokeiyakuNo) {
            txt += getDelimiter(txt);
            txt += `入居契約No.:${this.nyukyokeiyakuNo}`;
        }
        if (this.nyukyoshaName) {
            txt += getDelimiter(txt);
            txt += `入居者名:${this.nyukyoshaName}`;
        }
        return txt === "" ? "検索条件" : txt;
    }
}
